var kosan = kosan || {};

kosan.form = new function () {
    var self = this;

    this.init = function () {

        var formEl = document.querySelector('.grid-form form');

        if (formEl) {
            formEl.setAttribute("autocomplete", "nope");

            var inputEl = document.querySelectorAll('.grid-form form input');
            for (var i = 0; i < inputEl.length; i++) {
                inputEl[i].setAttribute("autocomplete", "nope");
            }
        }
    };
}